import { render, staticRenderFns } from "./FileForm.vue?vue&type=template&id=7aa062a8&scoped=true"
import script from "./FileForm.vue?vue&type=script&lang=js"
export * from "./FileForm.vue?vue&type=script&lang=js"
import style0 from "./FileForm.vue?vue&type=style&index=0&id=7aa062a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa062a8",
  null
  
)

export default component.exports